//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchEmployeeRequest,
  fetchEmployeeSuccess,
  fetchEmployeeFailure,
  fetchCaseHistoryRequest,
  fetchCaseHistorySuccess,
  fetchCaseHistoryFailure,
  bankAccountDetailRequest,
  bankAccountDetailSuccess,
  bankAccountDetailFailure,
  fetchViewRlhRewardsRequest,
  fetchViewRlhRewardsSuccess,
  fetchViewRlhRewardsFailure,
} from '../reducer/profileSlice';
import {
  fetchemployeeProfile,
  fetchCaseHistory,
  fetchBankAccountDetail,
  fetchViewRlhRewards,
} from '../api';
interface profileAction {
  type: typeof fetchEmployeeRequest.type;
  type: typeof fetchCaseHistoryRequest.type;
}
interface bankAccountDetailAction {
  type: typeof bankAccountDetailRequest.type;
}

interface viewRlhRewardsAction {
  type: typeof fetchViewRlhRewardsRequest.type;
}

export function* fetchEmployeeRequestSaga(
  action: profileAction
): Generator<any, void, unknown> {
  try {
    const { accountId } = action.payload;
    const employee: any = yield call(
      fetchemployeeProfile,
      'fetch_employee_profile',
      accountId
    );
    if (employee?.statusCode === 200) {
      yield put(fetchEmployeeSuccess(employee));
    } else {
      yield put(fetchEmployeeFailure(employee?.response?.data));
    }
  } catch (error: any) {
    yield put(fetchEmployeeFailure(error));
  }
}

export function* fetchCaseHistoryRequestSaga(
  action: caseHistoryAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId } = action.payload;
    const caseHistory: any = yield call(
      fetchCaseHistory,
      'fetch_casehistory',
      accountId,
      customerId
    );
    yield put(fetchCaseHistorySuccess(caseHistory));
  } catch (error: any) {
    yield put(fetchCaseHistoryFailure(error));
  }
}

export function* bankAccountDetailSaga(
  action: bankAccountDetailAction
): Generator<any, void, unknown> {
  try {
    const { accId } = action.payload;

    const bankAccountDetailResponse: any = yield call(
      fetchBankAccountDetail,
      'fetch_bank_account_detail',
      accId
    );
    // console.log("bankAccountDetailResponse", bankAccountDetailResponse);
    yield put(bankAccountDetailSuccess(bankAccountDetailResponse));
  } catch (error: any) {
    yield put(
      bankAccountDetailFailure(error || 'Failed to bank account detail')
    );
  }
}

// Fetch view rewards
export function* fetchViewRlhRewardsSaga(
  action: viewRlhRewardsAction
): Generator<any, void, unknown> {
  try {
    console.log('payload', action.payload);
    const {ban, accountId} = action.payload;
    const viewRewards: any = yield call(
      fetchViewRlhRewards,
      'request_view_rewards',
      ban,
      accountId
    );
    yield put(fetchViewRlhRewardsSuccess(viewRewards)); // Assuming API response has a `status` field
  } catch (error: any) {
    yield put(
      fetchViewRlhRewardsFailure(
        error.message || 'Failed to fetch view rewards.'
      )
    );
  }
}

// Watch employee profile sagas
export function* watchEmployeeProfileSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchEmployeeRequest.type, fetchEmployeeRequestSaga);
  yield takeLatest(fetchCaseHistoryRequest.type, fetchCaseHistoryRequestSaga);
  yield takeLatest(bankAccountDetailRequest.type, bankAccountDetailSaga);
  yield takeLatest(
    fetchViewRlhRewardsRequest.type,
    fetchViewRlhRewardsSaga
  );
}
